import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Realizacije, ApiClientService } from '../../../../services/api-client.service';

@Component({
  selector: 'app-create-realizacije',
  templateUrl: './create-realizacije.component.html',
  styleUrls: ['./create-realizacije.component.scss']
})
export class CreateRealizacijeComponent {
  @Input() set visible(value: boolean) {
    this.isVisible = value;
    if (value) {
      this.initializeForm();
    }
  }

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() realizacijeCreated = new EventEmitter<Realizacije>();

  isVisible = false;
  loading = false;
  realizacijeForm!: FormGroup;
  maxDate = new Date();

  datumEditorOptions: any = {
    placeholder: 'Odaberite datum...',
    type: 'date',
    max: this.maxDate,
    displayFormat: "dd.MM.yyyy"
  };

  tekstEditorOptions: any = {
    placeholder: 'Unesite tekst realizacija...',
    autoResizeEnabled: true,
    height: 100
  };

  constructor(
    private fb: FormBuilder, 
    private apiClient: ApiClientService
  ) {}

  onPopupShown() {
    this.initializeForm();
  }

  initializeForm() {
    this.realizacijeForm = this.fb.group({
      datum: [new Date().toISOString().split('T')[0], Validators.required],
      tekst: ['', Validators.required]
    });
  }

  onFieldDataChanged(e: any) {
    if (e.dataField && e.value !== undefined) {
      this.realizacijeForm.patchValue({
        [e.dataField]: e.value
      });
    }
  }

  onPopupHiding() {
    this.isVisible = false;
    this.visibleChange.emit(false);
  }

  onCancel() {
    this.isVisible = false;
    this.visibleChange.emit(false);
    this.realizacijeForm.reset();
  }

  async onSubmit() {
    if (this.realizacijeForm.valid) {
      this.loading = true;

      try {
        const createdRealizacije = await this.apiClient.realizacijePOST(this.realizacijeForm.value);

        this.realizacijeCreated.emit(createdRealizacije);
        this.isVisible = false;
        this.visibleChange.emit(false);
        this.realizacijeForm.reset();

      } catch (error) {
        console.error('Error creating realizacije:', error);
      } finally {
        this.loading = false;
      }
    } else {
      this.markFormGroupTouched(this.realizacijeForm);
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control?.markAsTouched();
      }
    });
  }
}